export const GET_NOTIFICATION_START = 'GET_NOTIFICATION_START';

export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';

export const GET_NOTIFICATION_FAILURE = 'GET_NOTIFICATION_FAILURE';
